import React from "react"
import { Icon, IconProps } from "@mui/material"
import { useStyles } from "./styles"
import { IconSize } from "./types"

export { default as FaIcon } from "./FaIcon"

interface Props {
  size?: IconSize
  IconProps?: IconProps
  style?: any
  className?: string
  classes?: object
}

export const WarningIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fa",
        "fa-exclamation-triangle",
        classes[props.size || "small"],
        props.className || ""
      )}
      {...props.IconProps}
    />
  )
}

export const CheckCircleIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", " fa-check-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}

export const InfoAlertIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fa",
        "fa-exclamation-circle",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}

export const InfoSparklesIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-sparkles",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}

export const ErrorAlertIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fa",
        "fa-exclamation-circle",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}

export const RedoIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-redo", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const UndoIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-undo", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const AddIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-plus-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SubstractIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-minus-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const MenuIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-ellipsis-h", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowBackIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-arrow-left", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RemoveIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-times-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const DeleteIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-trash", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RenameIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-i-cursor", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PublishIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-rocket", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const DuplicateIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-copy", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LinkIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-link", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const FilterFilledIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-filter", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const FilterEmptyIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-filter", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const EditIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fa",
        "fa-pen",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const HintIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-lightbulb", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PresentationIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-presentation", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VideoIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-video", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ImageIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-image", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ContentIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-font-case", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const QuestionIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-question", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VideoLinkIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fab", "fa-youtube", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VideoRecordIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-webcam", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const UploadIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-upload", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LibraryIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-photo-video", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const TranscriptIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-file-alt", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PlayIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-play", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PauseIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pause", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ViewIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-eye", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}

export const ReportIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pennant", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const OneColumnIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-square", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const BalancedColumnsIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pause", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LargeLeftColumnIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pause", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LargeRightColumnIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-pause", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ExpandMoreIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fal", "fa-angle-down", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CloseIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-times",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const ArrowCircleLeftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-arrow-circle-left",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const ArrowCircleRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-arrow-circle-right",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const GripVerticalIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-grip-vertical", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const FeedbackIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-comment-alt-dots",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const ExternalLinkIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-external-link", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const BreadcrumbIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-angle-right", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const FabAddIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-plus", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const DropdownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-caret-down", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const DebugIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-debug", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const BranchIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("far", "fa-network-wired", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SettingsIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-cog", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const LayoutsIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-bring-forward", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const AnswerIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-ballot", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CircleDownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-arrow-alt-circle-down",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const CircleUpIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-arrow-alt-circle-up",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}

export const TextSizeIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("far", "fa-text-size", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowsHorizontalIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrows-alt-h", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RefreshIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-sync", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowsAltIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrows-alt", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CropIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-crop", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SearchIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-search", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SearchMinusIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-search-minus", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SearchPlusIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-search-plus", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowUpIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrow-up", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowDownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrow-down", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowLeftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrow-left", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrow-right", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RotateLeftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-undo", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const RotateRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-undo",
        "fa-flip-horizontal",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const ArrowsVerticalIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-arrows-alt-v", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CheckIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa ", "fa-check", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CircleIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ExpandIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-expand", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const CompressIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-compress", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const MinusSquareIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-minus-square", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PlusSquareIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-plus-square", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VolumeUpIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-volume-up", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const VolumeMuteIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-volume-mute", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const HandPointRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-hand-point-right",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const ChevronDownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-chevron-down", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ChevronUpIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-chevron-up", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ChevronLeftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-chevron-left", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ChevronRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-chevron-right", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const InfoCircle = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-info-circle",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const BookIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-book", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}

export const BooksIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-books", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}

export const BookOpenIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-book-open", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const DownloadIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-download", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SmileWinkIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fal ", "fa-smile-wink", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ExclamationIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa ", "fa-exclamation", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const AwardIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-award", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SpinnerIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-spinner fa-pulse",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const HomeIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-home", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const HouseIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa-solid", "fa-house", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const UsersIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-users", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const QuestionCircleIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-question-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const UserCircleIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-user-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SignOutIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-sign-out-alt", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const IdBadgeIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-id-badge", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const FileChartPieIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-file-chart-pie", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const EyeSlashIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-eye-slash", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const EyeIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-eye", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ClearIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-times", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const PdfIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-file-pdf", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const GridIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-th-large", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ListIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-th-list", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}

export const SortDownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-sort-amount-down",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const SortNumericDownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-sort-numeric-down",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const SortNumericUpIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-sort-numeric-up",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const SortAlphaUpIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-sort-alpha-up", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SortAlphaDownIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-sort-alpha-down",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const ClockIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-clock",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}

export const StopwatchIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-stopwatch",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}

export const LockIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-lock",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const UnlockIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-unlock", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ChalkboardTeacherIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-chalkboard-teacher",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const CityIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas ", "fa-city", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const SchoolIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-school", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const UserClassIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-users-class", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const UserIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-user", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const BarsIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-bars", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ExchangeIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("far", "fa-exchange", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const TextIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fa", "fa-file-csv", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const ArrowRotateLeftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-undo", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const MenuDotsVerticalIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fa ",
        "fa-ellipsis-v",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const SortIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-sort",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const FileCSVIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas ",
        "fa-solid",
        "fa-file-csv",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const ArrowLeftLongIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fa ",
        "fa-long-arrow-left",
        classes[props.size || "small"]
      )}
      {...props.IconProps}
    />
  )
}
export const GiftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-gift", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}
export const AngleLeftIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-angle-left",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const AngleRightIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-angle-right",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const GraduationIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-graduation-cap",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const MessageIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-message",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
export const ChartLineIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-chart-line", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}

export const CalendarIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-calendar",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}

export const PlusIcon: React.FC<Props> = props => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-plus",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}

export const MinusIcon: React.FC<Props> = props => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-minus",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}

export const ExpandAllIcon: React.FC<Props> = props => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fa-solid",
        "fa-angles-down",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}

export const CollapseAllIcon: React.FC<Props> = props => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fa-solid",
        "fa-angles-up",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}

export const ScoreIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx("fas", "fa-pen-circle", classes[props.size || "small"])}
      {...props.IconProps}
    />
  )
}

export const KeyIcon = (props: Props) => {
  const { classes, cx } = useStyles()
  return (
    <Icon
      style={props.style}
      className={cx(
        "fas",
        "fa-key",
        classes[props.size || "small"],
        props.className
      )}
      {...props.IconProps}
    />
  )
}
